import sanitizeHtml from 'sanitize-html';

const sanitize = (dirty_html, compact) => sanitizeHtml(dirty_html, {
  // defensive list of allowed stuff; probably we can allow anything since we configured the WYSIWYG editor
  // note: the style attrib is potentially page-breaking if the user does something crazy with it somehow
  allowedAttributes: {
    '*': ['href', 'name', 'target', 'data-*'],
    'img': ['src'],
  },
  transformTags: compact ? { // make it so h3 is the largest header tag rendered:
    'h1': 'p',
    'h2': 'p',
    'h3': 'p',
    'h4': 'p',
    'h5': 'p',
  } : null,
});

export default {
  inserted: (el, binding) => {
    const target = document.createElement(`span`);
    target.dataset.sanitise_directive = true;
    target.innerHTML = sanitize(binding.value, binding.arg);
    el.appendChild(target);
  },
  update: (el, binding) => {
    const target = (() => {
      const spans = [...el.querySelectorAll(`span`)];
      return spans.find(span_el => span_el.dataset.sanitise_directive);
    })();
    if (target) {
      target.innerHTML = sanitize(binding.value, binding.arg);
    }
  },
};
